import React from 'react'
import { Box, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(
  ({ spacing, palette, typography, breakpoints }) => ({
    root: {
      [breakpoints.up('md')]: {
        maxWidth: 375
      }
    },
    title: {
      ...typography.heading.h5,
      fontWeight: typography.fontWeightMedium,
      color: palette.grey.shade[90],
      marginBottom: spacing(3.5)
    },
    subtitle: {
      ...typography.body.s,
      fontWeight: typography.fontWeightBold,
      color: palette.grey.shade[100],
      marginBottom: spacing(1)
    },
    body: {
      ...typography.body.s,
      color: palette.grey.shade[100],
      marginBottom: spacing(1.2)
    },
    divider: {
      backgroundColor: palette.common.black,
      marginBottom: spacing(1.2),
      marginTop: spacing(2)
    }
  })
)

const DiscountCompletePanel = ({
  discount,
  'data-test': testAttr = 'retention-complete-discount-panel'
}) => {
  const classes = useStyles()
  return (
    <Box data-test={testAttr} className={classes.root}>
      <Typography className={classes.title}>Offer details include</Typography>
      <Typography className={classes.subtitle}>
        {discount?.amount}% off all future payments
      </Typography>
      <Typography className={classes.body}>
        Discount applies from the next billing date.
      </Typography>
      <Typography className={classes.subtitle}>
        Keep using all of your features
      </Typography>
      <Typography className={classes.body}>
        Nothing changes, keep using your subscription as usual.
      </Typography>
    </Box>
  )
}

export default DiscountCompletePanel
